import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, msg } from './hubApi';
import { useApp } from './HubContext';

export function GoLive({ user, setUser }) {
  const st = user.stream || {};
  const [f, setF] = useState({ url: st.url || '', title: st.title || '', showPicks: st.showPicks || 'ALL' });
  const [note, setNote] = useState('');
  const save = async () => { try { await api('/me/stream', { method: 'PATCH', body: f }); setUser(await api('/me')); setNote('Saved'); } catch (e) { setNote(msg(e)); } };
  const toggle = async on => { try { await api('/me/stream/live', { method: 'POST', body: { live: on } }); setUser(await api('/me')); setNote(on ? 'You are live.' : 'Stream ended.'); } catch (e) { setNote(msg(e)); } };
  return (
    <section className="card">
      <h2>Live stream</h2>
      <p className="fine">Stream on YouTube, Twitch or Kick as usual, paste the link here and press Go live. Your viewers chat on Betbuilder, and every pick you publish while live pops up in the chat. Commentary only: don’t show race vision, and don’t urge people to bet.</p>
      <div className="grid4">
        <label className="grow">Stream link<input value={f.url} placeholder="https://youtube.com/live/… or twitch.tv/… or kick.com/…" onChange={e => setF({ ...f, url: e.target.value })} /></label>
        <label>Title<input value={f.title} maxLength={80} onChange={e => setF({ ...f, title: e.target.value })} /></label>
        <label>Who sees picks before the jump<select value={f.showPicks} onChange={e => setF({ ...f, showPicks: e.target.value })}>
          <option value="ALL">Everyone watching</option><option value="FOLLOWERS">Followers only</option></select></label>
      </div>
      <div className="row">
        <button className="ghost sm" onClick={save}>Save</button>
        {st.live ? <button className="danger sm" onClick={() => toggle(false)}>End stream</button> : <button className="sm" disabled={!st.embed} onClick={() => toggle(true)}>Go live</button>}
        {st.live && <Link to={'/hub/watch/' + user.handle}>Open your stream page</Link>}
        <span className="note">{note}</span>
      </div>
    </section>
  );
}

const money = n => 'A$' + Number(n || 0).toFixed(2);
const dt = iso => iso ? new Date(iso).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Australia/Sydney' }) : '–';

function Selling() {
  const [s, setS] = useState(null);
  const [f, setF] = useState(null);
  const [note, setNote] = useState('');
  const load = () => api('/me/selling').then(d => { setS(d); setF(d.pricing); });
  useEffect(() => { load(); }, []);
  if (!s) return null;
  const save = async () => {
    setNote('Saving…');
    try { const d = await api('/me/selling', { method: 'PUT', body: { day: Number(f.day) || 0, week: Number(f.week) || 0, month: Number(f.month) || 0, payoutEmail: f.payoutEmail } }); setS(d); setF(d.pricing); setNote('Saved. Your prices are live on your profile.'); }
    catch (e) { setNote(msg(e)); }
  };
  const e = s.earnings;
  return (
    <section className="card">
      <h2>Sell your tips</h2>
      <p className="fine">Set your own prices. Leave a price at 0 to not offer it; all 0 means anyone can follow you free. Buyers get your picks before the jump and can mirror them in units. Betbuilder keeps {s.feePct}%; you’re paid weekly to your PayPal email once each payment has cleared a {s.holdDays}-day hold (minimum A${s.minPayout}).</p>
      <div className="grid4">
        <label>Today’s tips (one-off) A$<input type="number" min="0" step="0.5" value={f.day} onChange={ev => setF({ ...f, day: ev.target.value })} /></label>
        <label>1 week A$<input type="number" min="0" step="0.5" value={f.week} onChange={ev => setF({ ...f, week: ev.target.value })} /></label>
        <label>1 month A$<input type="number" min="0" step="0.5" value={f.month} onChange={ev => setF({ ...f, month: ev.target.value })} /></label>
        <label className="grow">PayPal email for payouts<input type="email" value={f.payoutEmail} onChange={ev => setF({ ...f, payoutEmail: ev.target.value })} /></label>
      </div>
      <p className="fine">Week and month can be bought once or as an automatic renewal{s.pricing.week > 0 && !s.pricing.weekRecurring ? ' (renewals switch on once PayPal is connected)' : ''}.</p>
      <div className="row"><button className="sm" onClick={save}>Save prices</button><span className="note">{note}</span></div>
      <div className="stats" style={{ marginTop: 12 }}>
        <div><b>{s.activeBuyers}</b><span>buyers with access</span></div>
        <div><b>{money(e.gross)}</b><span>total sales</span></div>
        <div><b>{money(e.held)}</b><span>your share on hold</span></div>
        <div><b>{money(e.available)}</b><span>ready for next payout</span></div>
        <div><b>{money(e.paid)}</b><span>paid to you</span></div>
      </div>
      {!!s.recentSales.length && <div className="scroll"><table>
        <thead><tr><th>Date</th><th>Sold</th><th className="r">Price</th><th className="r">Your share</th><th>Status</th></tr></thead>
        <tbody>{s.recentSales.map((x, i) => <tr key={i}><td>{dt(x.paidAt)}</td><td>{{ DAY: "Today's tips", WEEK: '1 week', MONTH: '1 month' }[x.kind]}</td><td className="r">{money(x.gross)}</td><td className="r">{money(x.leaderShare)}</td>
          <td>{x.status === 'PAID' ? 'Paid out' : x.status === 'HELD' ? 'On hold until ' + dt(x.availableAt) : x.status}</td></tr>)}</tbody>
      </table></div>}
    </section>
  );
}

function Purchases() {
  const [rows, setRows] = useState(null);
  const [note, setNote] = useState('');
  const load = () => api('/me/purchases').then(setRows);
  useEffect(() => { load(); }, []);
  const cancel = async id => { if (!window.confirm('Cancel automatic renewal? You keep access until the end of the paid period.')) return; try { await api(`/billing/passes/${id}/cancel`, { method: 'POST' }); load(); setNote('Renewal cancelled.'); } catch (e) { setNote(msg(e)); } };
  if (!rows) return null;
  return (
    <section className="card">
      <h2>My purchases</h2>
      {!rows.length ? <p className="fine">No purchases yet. Browse the <Link to="/hub/leaderboard">leaderboard</Link> to find leaders to follow.</p> :
        <div className="scroll"><table>
          <thead><tr><th>Leader</th><th>Access</th><th className="r">Price</th><th>Status</th><th>Until</th><th>Receipts</th><th></th></tr></thead>
          <tbody>{rows.map(p => (
            <tr key={p.id}>
              <td><Link to={'/hub/leaders/' + p.leader.handle}>{p.leader.displayName}</Link></td>
              <td>{p.label}{p.recurring ? ' · recurring' : ''}</td><td className="r">{money(p.price)}</td>
              <td>{{ ACTIVE: p.recurring ? 'Active, renews' : 'Active', CANCELLED: 'Cancelled (access continues)', EXPIRED: 'Ended' }[p.status] || p.status}</td>
              <td>{dt(p.endsAt)}</td>
              <td>{p.payments.map(x => <Link key={x.id} to={'/hub/receipt/' + x.id} className="rcpt">{dt(x.paidAt)}</Link>)}</td>
              <td>{p.recurring && p.status === 'ACTIVE' && <button className="ghost sm" onClick={() => cancel(p.id)}>Cancel renewal</button>}</td>
            </tr>))}</tbody>
        </table></div>}
      {note && <p className="note">{note}</p>}
    </section>
  );
}

export default function Account() {
  const { user, setUser } = useApp();
  const [bank, setBank] = useState(user.leaderboard?.declaredBank || user.bank || 1000);
  const [admin, setAdmin] = useState(false);
  useEffect(() => { api('/me/admin').then(r => setAdmin(r.admin)).catch(() => {}); }, []);
  const opt = async optIn => setUser(await api('/me/leaderboard', { method: 'POST', body: { optIn, declaredBank: Number(bank) } }));
  return (
    <>
      {admin && <p className="note"><Link to="/hub/admin">Open the admin page (sales, payouts)</Link></p>}
      <section className="card">
        <h2>Betfair connection</h2>
        <p>{user.betfair?.mode === 'MOCK' ? 'Connected to the demo exchange. No real money is used.' : user.betfair?.connected ? 'Your Betfair account is connected.' : 'Not connected.'}</p>
        <p className="fine">Betbuilder never holds your betting money. Bets are placed in your own Betfair account and you can disconnect at any time.</p>
      </section>
      <Purchases />
      <section className="card">
        <h2>Leaderboard</h2>
        <p className="fine">Opting in publishes the record of your <b>own picks</b>, in units (curated tips from other tipsters are never shown). Other users can then mimic you. Your balance, unit size in dollars and account details are never shown.</p>
        <div className="row">
          <label>Declared starting bank $ (for “% of bank”)<input type="number" value={bank} onChange={e => setBank(e.target.value)} /></label>
          {user.leaderboard?.optIn ? <button className="ghost" onClick={() => opt(false)}>Leave leaderboard</button> : <button onClick={() => opt(true)}>Join leaderboard</button>}
        </div>
        {user.leaderboard?.optIn && <p className="note">You’re on the leaderboard. <Link to={'/hub/leaders/' + user.handle}>View your public profile</Link></p>}
      </section>
      {user.leaderboard?.optIn && <Selling />}
      {user.leaderboard?.optIn && <GoLive user={user} setUser={setUser} />}
    </>
  );
}
